<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<NewIndexSiteLayout>
	<div class="container" ref="viewBox">		
		<div id="content" class="content" ref="content">
			<Loading :is-loading="isListLoading"></Loading>			
			<section class="section">
				<div class="ar-content">
					<div style="font-family: 黑体, SimHei; font-size: 24px;font-weight:bold;text-align: center;" v-html="relatedDetail.title"></div>
					<div style="font-family: 黑体, SimHei; font-size: 14px;color:#9b9b9b;margin:12px 0;">
						<span>{{relatedDetail.created_at}}</span>
						<span style="margin-left:20px;">{{$t('contentViews')}} {{views}}</span>
					</div>					
					<div class="html-content" style="margin-top: 20px;" id="html-content" v-html="relatedDetail.content"></div>					
				</div>
			</section>
		</div>		
		<Footer/>
	</div>
	</NewIndexSiteLayout>
	
</template>

<script>
	import related_news_detail from './related_news_detail_controller';
	export default related_news_detail;
</script>

<style src="@/assets/css/related_news_detail.css" scoped></style>
<!-- 这段全局css代码在related_news_detail.vue,subject_detail.vue,tail_detail.vue都有，而且相同。 -->
<style>
/*.ar-content .html-content p img{
	width:86%!important;
	height:auto!important;
	object-fit: contain;

}
@media screen and (max-width: 767px) {
	.ar-content .html-content p img{
		width:100%!important;
		max-width:375px!important;
		height:auto!important;
	}
}*/
</style>

